import Pusher from 'pusher-js';

// Develop
const ENDPOINT = HTTP_API + 'pusher/auth';
const KEY = PUSHER_KEY;

Pusher.log = function (message) {
  console.log('PUSHER LOG - ', message);
};

var socket;

function connect () {
  console.log('PUSHER CONNECTING')
  socket = new Pusher(KEY, {
    encrypted: true,
    authEndpoint: ENDPOINT,
    auth: {
      headers: {
        'Authorization': 'bearer ' + window.AppData.$store.getters.token.access_token
      }
    }
  });
  
  const privateChannel = socket.subscribe('private-' + window.AppData.$store.getters.profile._id);
  const presenceChannel = socket.subscribe('presence-' + window.AppData.$store.getters.profile._id);
  var unavailable = false;
  var state = { };
  
  socket.connection.bind('state_change', function (states) {
    state = states;
  
    // UNAVAILABLE //
    if (state.current === 'unavailable') {
      // window.setOnlineStatus(false);
      unavailable = true;
    }
  
    // CONNECTED TO CONNECTING //
    if (state.previous === 'connected' && state.current === 'connecting') {
      unavailable = true;
      // window.setOnlineStatus(false);
    }
  
    // CONNECTING //
    if (state.current === 'connecting') {
    }
  
    // UNAVAILABLE TO CONNECTED //
    if (unavailable && state.current === 'connected') {
      // window.setOnlineStatus(true);
      
      document.dispatchEvent(
        new CustomEvent('reconnected', {
          detail: { name: 'reconnected' }
        })
      );
  
      unavailable = false;
    }
  });
  
  privateChannel.bind('users', function (data) {
    document.dispatchEvent(
      new CustomEvent('liveUpdate', {
        detail: { data: data }
      })
    );
  });
  
  presenceChannel.bind('update', function () {
  });
}


function disconnect () {
  socket.disconnect();
}


export default { connect, disconnect };


// WEBPACK FOOTER //
// ./src/scripts/pusher.js